const LOCALES_OBJ = {
  English: 'en',
  Norway: 'nb'
};

const PAYPAL_LOCALES_OBJ = {
  English: 'en_US',
  Norway: 'no_NO'
};

const INTEGRATIONS_CONSTANTS = {
  Trekksoft: 'TREKKSOFT',
  'Booking.com': 'BOOKING',
  Expedia: 'EXPEDIA',
  Airbnb: 'AIRBNB',
  Citybreak: 'CITYBREAK',
  TripAdvisor: 'TRIPADVISOR'
};

const INTEGRATIONS_NAMES = {
  TREKKSOFT: 'Trekksoft',
  BOOKING: 'BOOKING',
  EXPEDIA: 'Expedia',
  AIRBNB: 'Airbnb',
  CITYBREAK: 'Citybreak',
  TRIPADVISOR: 'TripAdvisor'
};

const WEEK_DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

const WEEKLY_BASE = ['weekday', 'weekend'];

const HOURLY_LIST = [
  '12 00 AM', '1 00 AM', '2 00 AM', '3 00 AM', '4 00 AM', '5 00 AM',
  '6 00 AM', '7 00 AM', '8 00 AM', '9 00 AM', '10 00 AM', '11 00 AM',
  '12 00 PM', '1 00 PM', '2 00 PM', '3 00 PM', '4 00 PM', '5 00 PM',
  '6 00 PM', '7 00 PM', '8 00 PM', '9 00 PM', '10 00 PM', '11 00 PM'
];



const USER_TYPE = {
  employee: 'EMPLOYEE',
  owner: 'OWNER'
};

export {
  LOCALES_OBJ,
  PAYPAL_LOCALES_OBJ,
  INTEGRATIONS_CONSTANTS,
  INTEGRATIONS_NAMES,
  WEEK_DAYS,
  USER_TYPE,
  WEEKLY_BASE,
  HOURLY_LIST
};
